import classNames, {Argument} from 'classnames';
import * as React from 'react';

interface OwnProps {
  className?: Argument;
  text: string;
  title?: string;
}

type Props = OwnProps;

export const HtmlText: React.FC<Props> = (props) => {
  const {className = '', text, title} = props;
  const markup = {__html: text};

  /* eslint-disable react/no-danger */
  return (
    <span
      className={classNames(className)}
      dangerouslySetInnerHTML={markup}
      title={title}
    />
  );
  /* eslint-enable react/no-danger */
};

HtmlText.displayName = 'HtmlText';
